export const styles = theme => ({
  root: {
    margin: '12px 0',
    paddingBottom: '16px',
    borderBottom: `1px solid ${theme.colors.grey[100]}`
  },
  chartIcons: {
    padding: '0px 16px',
    boxSizing: 'border-box',
    display: 'grid',
    gridTemplateColumns: 'repeat(6, 32px)',
    justifyContent: 'space-between',
    gap: '16px 10px'
  },
  chartType: {
    width: '32px',
    height: '32px',
    flex: '1',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: `1px solid ${theme.colors.grey[100]}`,
    borderRadius: 4,
    cursor: 'pointer'
  },
  chartTypeIcon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  chartTypeTooltipContent: {
    textAlign: 'center'
  },
  chartTypeIconDisabled: {
    cursor: 'not-allowed'
  },
  selected: {
    backgroundColor: theme.colors.grey[100],
    border: `1px solid ${theme.colors.grey[100]}`
  }
});
export default styles;